<app-error-page [errorMsg]="errorMsg" *ngIf="containsError"></app-error-page>

<div *ngIf="!containsError">
  <div class="view-purchase-advice-container">
    <div class="pageHeader" id="viewPurchaseAdviceHeader">View Purchase Advice</div>
    <div class="warningMessage" *ngIf="warningMessage"><br><li>{{warningMessage}}</li></div>

    <div class="errorMessage" *ngIf="errorMessage?.length">
      <br>
      You must correct the following error(s) before proceeding:
      <li *ngFor="let message of errorMessage">{{message}}</li>
    </div>

    <!-- Form 1 - Fannie Mae Loan Number -->
    <div class="ui-g commonLabel">Please select one of the search criteria below:</div>
    <form [formGroup]="viewPurchaseAdviceLoanCriteriaForm">
      <div class="view-purchase-advice-loan-form">
        <!-- Main div -->
        <div>
          <div class="ui-g">
            <div class="ui-g-3 fieldLabel glypha-font">Fannie Mae Loan Number:</div>
            <div class="ui-g-2">
              <input type="text" fmTextInput id="loanNumber" maxlength="10" formControlName="loanNumber">
            </div>
          </div>
          <div class="ui-g">
            <div class="ui-g-8 buttons">
              <button fmButton id="btnLoanCriteriaSubmit" type="submit" [primary]="true" [small]="true" label="Submit" (click)="onSubmit(true)"
                      class="loanButton submitBtn"></button>
              <button fmButton id="btnLoanCriteriaClear" type="button" label="Clear" [small]="true" (click)="onLoanCriteriaClear()"
                      class="loanButton"></button>
              <button fmButton id="btnLoanCriteriaCancel" type="button" label="Cancel" [small]="true" routerLink="/reverseMortgage"
                      class="loanButton"></button>
              <button fmButton id="btnLoanCriteriaDownloadToExcel" type="button" label="Download to Excel" [small]="true" (click)="downloadExcel(true)"
                      class="loanButton"></button>
            </div>
          </div>
        </div>
        <!-- End of main div -->
      </div>
    </form>

    <!-- Form 2 - Lender Loan ID -->
    <form [formGroup]="viewPurchaseAdviceLenderCriteriaForm">
      <div class="view-purchase-advice-lender-form">
        <!-- Main div -->
        <div>
          <div class="ui-g">
            <div class="ui-g-3 fieldLabel glypha-font">Lender Loan ID:</div>
            <div class="ui-g-2">
              <input type="text" fmTextInput id="lenderLoanID" maxlength="10" formControlName="lenderLoanID">
            </div>
          </div>
          <div class="ui-g">
            <div class="ui-g-3 fieldLabel glypha-font">Servicer Number:</div>
            <!-- Auto populates servicer number if user is external -->
            <div class="ui-g-2" *ngIf="purchase.isExternal">
              <fm-select [options]="servicerNumbers" ariaLabelledBy="default" formControlName="servicerNumber"></fm-select>
            </div>
            <!-- Leaves box empty if user is internal -->
            <div class="ui-g-2" *ngIf="!purchase.isExternal">
              <input type="number" fmTextInput id="servicerNumber" fmTooltip="Enter servicer number" tooltipPosition="right" maxlength="10" formControlName="servicerNumber">
            </div>
          </div>
          <div class="ui-g">
            <div class="ui-g-3 fieldLabel glypha-font">Date: <i>(MM/DD/YYYY)</i></div>
            <div class="ui-g-3">
              <fm-calendar
                id="date"
                dateFormat="mm/dd/yy"
                placeholder="MM/DD/YYYY"
                formControlName="date"
                [monthNavigator]="true"
                [yearNavigator]="true"
                [yearRange]="('1900:2050')"
                [showClear]="true">
              </fm-calendar>

            </div>
          </div>
          <div class="ui-g">
            <div class="ui-g-8 buttons">
              <button fmButton id="btnLenderCriteriaSubmit" type="submit" [primary]="true" [small]="true" label="Submit" (click)="onSubmit(false)"
                      class="lenderButton submitBtn"></button>
              <button fmButton id="btnLenderCriteriaClear" type="button" label="Clear" [small]="true"
                      (click)="onLenderCriteriaClear()"
                      class="lenderButton"></button>
              <button fmButton id="btnLenderCriteriaCancel" type="button" label="Cancel" [small]="true" routerLink="/reverseMortgage"
                      class="lenderButton"></button>
              <button fmButton id="btnLenderCriteriaDownloadToExcel" type="button" label="Download to Excel" [small]="true" (click)="downloadExcel(false)"
                      class="lenderButton"></button>
            </div>
            <div class="ui-g-4"></div>
          </div>
        </div>
        <!-- End of main div -->
      </div>
    </form>
  </div>
  <fm-dialog header="{{fileName}}" [alignLeft]="true" [(visible)]="displayDialog" [modal]="true" [width]="1000"
             [responsive]="true" [dismissableMask]="true">
    <fm-header-template>
      <i class="fmi fmi-print report-print" title="Print" aria-hidden="true" (click)="reportPrint()"></i>
      <i class="fmi fmi-download download-button" title="Download" aria-hidden="true" (click)="downloadFile()"></i>
    </fm-header-template>
    <div id="pdfRenderer" allowFullScreen="true" class="iframe-container">
      <iframe *ngIf="safePdfURL" width="100%" height="100%" id ="pdfRendererIframe" title="PDFViewer" [src]="safePdfURL"></iframe>
    </div>

  </fm-dialog>
</div>
